module.exports = __webpack_public_path__ + "static/media/data_scheme@x2.922fca6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/mood/src/data_scheme@x2.png
// module id = 530
// module chunks = 0